import Component from '@cell/cell-core/component/component';
import './input.scss';

class Input extends Component {
  constructor() {
    super();

    this.handleInput = this.handleInput.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.handleReset = this.handleReset.bind(this);
  }

  componentDidMount() {
    this.on('input', this.handleInput);
    this.on('change', this.handleChange);

    this.on('c-button.click.reset', this.handleReset);
  }

  handleInput(event) {
    let value = event.target.value;

    if (event.target.type === 'number') {
      value = event.target.valueAsNumber;
    }

    // Enable/disable the button if the input is a search.
    if (this.querySelector('input') && this.querySelector('input').type === 'search') {
      if (value.trim() !== '') {
        this.querySelector('.Button:last-child').setAttribute('data-active', 'true');
      } else {
        this.querySelector('.Button:last-child').removeAttribute('data-active');
      }
    }

    this.emit('input', {
      value,
    });
  }

  handleChange(event) {
    let value = event.target.value;

    if (event.target.type === 'number') {
      value = event.target.valueAsNumber;
    }

    // Enable/disable the button if the input is a search.
    if (this.querySelector('input') && this.querySelector('input').type === 'search') {
      if (value.trim() !== '') {
        this.querySelector('.Button:last-child').setAttribute('data-active', 'true');
      } else {
        this.querySelector('.Button:last-child').removeAttribute('data-active');
      }
    }

    this.emit('change', {
      value,
    });
  }

  handleReset() {
    const value = '';

    this.querySelector('input').value = value;

    this.emit('reset', {
      value,
    });
  }

  getName() {
    return this.querySelector('input').getAttribute('name');
  }

  getValue() {
    return this.querySelector('input').value;
  }
}

customElements.define('c-input', Input);
